import { Appeals } from 'feature/appeals/view'
import { MainLayout } from 'layouts'

export function AppealsPage() {
  return (
    <MainLayout>
      <div className='container'>
        <Appeals />
      </div>
    </MainLayout>
  )
}
